<template>
    <div class="page contact">
        <h1>Contact</h1>
        <p>Thanks for your interest in getting in touch! We'd love to hear from you.</p>
        <ul>
            <li>To report an error in our data, email <a href="mailto:support@openalex.org">support@openalex.org</a>.</li>
            <li>To report bugs, drop us a line at <a href="mailto:support@unpaywall.org">support@unpaywall.org</a></li>
            <li>For everything else, please contact <a href="mailto:team@ourresearch.org">team@ourresearch.org</a></li>
        </ul>
        <p>If you want to keep up with our goings-on, there are a few more options. You can follow us on Twitter at <a href="https://twitter.com/OurResearch_org">@OurResearch_org</a> and <a href="https://twitter.com/unpaywall">@unpaywall,</a> subscribe to the
            <a href="https://groups.google.com/forum/#!forum/unpaywall">Unpaywall mailing list, </a>  or follow us on
            <a href="https://github.com/ourresearch">GitHub.</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Contact",
        metaInfo: {
            title: "Contact"
        }
    }
</script>

<style scoped>

</style>

